import type { ReactElement } from 'react'
import { Paper } from '~/components/Global/Blocks/Paper/Paper'
import { PaperTitle } from '~/components/Global/Blocks/Paper/PaperTitle'
import type { DashboardBlockLayoutProps } from '../../types'
import { blockDraggableHeader } from './DashboardBlock.css'

export const DashboardBlockLayout = ({
  children,
  icon,
  title,
  actions,
  draggable,
  dragHandleRef
}: DashboardBlockLayoutProps): ReactElement => (
  <Paper>
    <PaperTitle
      icon={icon}
      ref={dragHandleRef}
      titleClassName={(draggable && blockDraggableHeader) || undefined}
      actions={actions}
    >
      {title}
    </PaperTitle>
    <div>{children}</div>
  </Paper>
)
